var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart-captcha",attrs:{"data-sitekey":"ysc1_xLuuPvqIKXkU7x3tCGlPXv8oprVpbjUOYjfUJupG4d3c35c5","data-callback":"getToken"}})
}
var staticRenderFns = []

export { render, staticRenderFns }